import axios from 'axios';
import { LANGUAGE_KEY } from '../consts/locale';

const API_URL = process.env.REACT_APP_API_URL;
export const axiosInstance = axios.create({
	baseURL: API_URL,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
	},
});

axiosInstance.interceptors.request.use(
	config => {
		const token = localStorage.getItem('accessToken');
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		config.headers['Accept-Language'] =
			localStorage.getItem(LANGUAGE_KEY) || 'en';
		return config;
	},
	error => Promise.reject(error),
);
